import React from "react";
import UserLayout from "../../components/Layout/UserLayout";
import { spanishbooktranslationfold1 } from "../../asserts/images";
import InnerHero from "../../components/InnerHero";
import Section2 from "../../components/Section2";
import CustomCategory from "../../components/CustomCategory";
import SecondCustomBanner from "../../components/SecondCustomBanner";
import FirstCustomBanner from "../../components/FirstCustomBanner";
import PublishBook from "../../components/PublishBook";
import Testimonial from "../../components/Testimonial";
import CustomPublication from "../../components/CustomPublication";
import Faq from "../../components/Faq";
import GetTouch from "../../components/GetTouch";
import { Helmet } from "react-helmet";

const GhostWriter = () => {
  return (
    <>

      <Helmet>
        <meta charSet="utf-8" />
        <title>
            Spanish Book Translation Services
        </title>
        <meta
          name="description"
          content="Translate your book into Spanish with accuracy, cultural nuance, and reader engagement in mind."
        />
        <meta name="keywords" content="Spanish Book Translation" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <UserLayout>
        <InnerHero
          innerheroclass="ghostwritingBg spanishbooktranslationbg"
          title=""
          subtitle=" Spanish Book Translation "
          title2="That Preserves Meaning and Style"
          para="Our Spanish book translation ensures every word, nuance, and tone of your original work is preserved. We deliver accurate, culturally sensitive translations that maintain your story’s style, emotion, and voice for Spanish-speaking readers worldwide."
        />

        <Section2
          innerSec2Class="innerbrilliant_mind_section innerpages-sec-2"
          title={`Maintaining Your Story’s  `}
          subtitle="  Voice, Tone, and Emotion "
          title2=""
          description={`Translating a book into Spanish is more than converting words, it’s about preserving your story’s unique voice, tone, and emotional depth. Our Spanish book translation service ensures that every sentence reflects the intent, style, and feeling of the original manuscript. We carefully adapt idioms, cultural references, and phrasing to resonate naturally with Spanish-speaking readers, without losing the essence of your work. Whether it’s fiction, non-fiction, memoir, or children’s literature, we maintain the narrative’s rhythm, personality, and impact. Every translation is meticulously reviewed to ensure clarity, flow, and authenticity. By balancing accuracy with creativity, we deliver a Spanish edition that feels original, engaging, and true to your vision. Expand your readership and connect deeply with new audiences while keeping your story’s heart intact. `}
          // subtitle1="How we work?"
          // subtitle1Desc="At Random House Publishers, we pride ourselves on being the conduit through which your imagination flows into the world. Our ghostwriting service is designed to empower authors like you to bring your stories to life, even if you need a little extra support along the way. Here’s how we work for you:"
          // subtitle2="    Tailored Collaborations?"
          // subtitle2Desc="We understand that every author is unique, and so are their needs. That’s why we offer personalized ghostwriting services tailored to your specific vision and requirements. Whether you have a fully fleshed-out plot or just a spark of an idea, our team of experienced ghostwriters will work closely with you to bring your story to fruition."
          // subtitle3="  Expert Guidance"
          // subtitle3Desc="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. From brainstorming sessions to plot development and character arcs, we’ll be there to guide you every step of the way."
          // subtitle3Desc2="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. "
          image={spanishbooktranslationfold1}
          imgClass="ghost-img2"
        />

        <CustomCategory className="category_section2" />
        <FirstCustomBanner />
        <PublishBook />
        <Testimonial />
        <SecondCustomBanner />
        <CustomPublication />
        <Faq />
        <GetTouch />
      </UserLayout>
    </>
  );
};

export default GhostWriter;
